import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.css']
})
export class ErrorsComponent implements OnInit {

  constructor(private sharedService:SharedService) { }
  public errorMessage ;
  ngOnInit() {
    this.errorMessage = this.sharedService.getErrorMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/errors/errors.component.ts